import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getAppSettingsUrl } from '../../constants/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export const GoToSettingsButton = ({
  appId,
  onClick
}) => {
  return /*#__PURE__*/_jsx(Button, {
    use: "secondary",
    href: getAppSettingsUrl(appId),
    marginBlockStart: "600",
    onClick: onClick,
    target: "_top",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goToSettingsButton.label"
    })
  });
};